// Component to detect if the user is on a mobile device it listens for when the window is resized and updates the state accordingly.
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setIsMobile } from "../redux/actions";

const MobileDetector = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const handleResize = () => {
      const isNowMobile = window.innerWidth <= 768;
      dispatch(setIsMobile(isNowMobile));
    };

    // Add resize event listener
    window.addEventListener("resize", handleResize);

    // Initial check
    handleResize();

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, [dispatch]);

  return null;
};

export default MobileDetector;
